(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Forms = Lfl.Forms || {};

    (function (Forms, $, undefined) {
        /**
         * @memberOf Lfl.Forms
         */
        Lfl.Forms.Inputs = Forms.Inputs || {};

        (function (Inputs, $, undefined) {
            if (Lfl.Files.isLoadedAlready(Lfl.Forms.Inputs, 'SimpleDropzone')) {
                return;
            }

            /*
             |==========================================================================================================
             | Class definition
             |==========================================================================================================
             */

            /**
             * @param {object} parameters
             * @param {object} parameters.dropzoneOptions
             * @param {string} parameters.dropzoneId
             * @param {string} parameters.submitButtonPath
             * @param {object} parameters.uploadHelper
             * @param {object} parameters.fileExtensionIconProvider
             * @memberOf Lfl.Forms.Inputs
             * @lends Lfl.Forms.Inputs.Dropzone
             * @constructor
             */
            Lfl.Forms.Inputs.SimpleDropzone = function (parameters) {

                var dropzone;

                var $form = $(parameters.dropzoneId).closest('form');

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Construction
                 |------------------------------------------------------------------------------------------------------
                 */

                var icons = {
                    addPhoto: parameters.uploadHelper.uploadIcon,
                    cancelUpload: '<i class="material-icons-outlined">cancel</i>',
                    removeFile: '<i class="material-icons-outlined">close</i>',
                    error: '<i class="material-icons">error_outline</i>'
                };


                var defaultOptions = {
                    url: parameters.uploadHelper.uploadUrl,
                    acceptedFiles: parameters.uploadHelper.acceptedMimetypes,
                    addRemoveLinks: true,
                    autoProcessQueue: true,
                    parallelUploads: parameters.uploadHelper.maxFiles,
                    maxFiles: parameters.uploadHelper.maxFiles,
                    maxFilesize: parameters.uploadHelper.maxFileSize,
                    headers: {
                        // TODO WIP - Fist::Core::UsableVersion - Do we want to send the xCsrfToken for server implementation? Should not make sense...
                        'X-Csrf-Token': parameters.uploadHelper.xCsrfToken,
                        "Access-Control-Allow-Origin": "*"
                    },
                    dictDefaultMessage: icons.addPhoto,
                    dictCancelUpload: icons.cancelUpload,
                    dictRemoveFile: icons.removeFile,

                    dictCancelUploadConfirmation: parameters.uploadHelper.cancelUploadConfirmationLangLine,
                    dictFileTooBig: parameters.uploadHelper.fileTooBigLangLine,
                    dictInvalidFileType: parameters.uploadHelper.invalidFileTypeLangLine,
                    dictMaxFilesExceeded: parameters.uploadHelper.maxFilesExceededLangLine,

                    init: onInitDropzone,
                };

                var mergedOptions = Object.assign(defaultOptions, parameters.dropzoneOptions);

                // Note: Using autoDiscover = false because we initialize manually.
                // In case it is ever needed, Dropzone.option name is camelized version of HTML ID
                dropzone = new Dropzone(parameters.dropzoneId, mergedOptions);
                Dropzone.autoDiscover = false;

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Public methods
                 |------------------------------------------------------------------------------------------------------
                 */

                this.getDropzone = function () {
                    return dropzone;
                };

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Private methods
                 |------------------------------------------------------------------------------------------------------
                 */

                /*
                |----------------------------------------------------------------------------------------
                | Functions
                |----------- */

                function onInitDropzone() {
                    // Register event handlers
                    this.on('processing', onProcessing);
                    this.on('sending', onSending);
                    this.on('success', onSuccess);
                    this.on('error', displayError);
                    this.on('removedfile', onRemovedFile);
                    this.on('complete', onComplete);

                    new Lfl.Forms.DisableSubmitButtonWhenDropzoneUploadingCoordinator(
                        {
                            dropzone: this,
                            submitButtonPath: parameters.submitButtonPath
                        })
                        .setUp();
                }

                /**
                 * @param {string} lflFileName
                 */
                function addNewFileToForm(lflFileName) {
                    $form.append(
                        '<input type="hidden" name="file" value="' + lflFileName + '">'
                    );
                }

                /**
                 * @param {string} lflFileName
                 */
                function removeNewFileFromForm(lflFileName) {
                    $form.find('input[name="file"][value="' + lflFileName + '"]').remove();
                }

                /**
                 * @param {string} name
                 */
                function addRemovedFileToForm(name) {
                    $form.append('<input type="hidden" name="removedFiles[]" value="' + name + '">');
                }

                /*
                |-------------------------------------------------------------------------
                | Handling events */
                function displayError(file, response) {
                    file.previewElement.querySelector('.dz-error-mark').innerHTML = icons.error;

                    if (file.xhr) {
                        console.log(response);
                        // TODO Review - Jabr -> better way of reporting such error?
                        //      Jabr: I think that this is fine. But consider removing the console.log above, or
                        //      using console.error("An error occured when uploading file, etc.", response);
                        $(file.previewElement).find('.dz-error-message')
                            // TODO WIP - Fist::Errors - Move to lang via passing errors to JS.
                            .text('Soubor se nepodařilo nahrát.');
                    }
                }

                function onProcessing(file) {
                    // Any operations that we would need to do before the resizing.
                }

                function onSending(file, xhd, formData) {
                    // Operations done after resizing.
                }

                function onSuccess (file, response) {
                    file.lflFileName = response.filename;

                    addNewFileToForm(file.lflFileName);
                }

                function onRemovedFile (file) {
                    // Remove file preview.
                    file.previewElement.remove();

                    if (file.status === "error") {
                        // do nothing with error files
                    } else {
                        removeNewFileFromForm(file.lflFileName);
                        addRemovedFileToForm(file.lflFileName);
                    }
                }

                function onComplete(file) {
                    if (file.status !== 'error') {
                        var iconUrl = parameters.fileExtensionIconProvider.getIconFromFileName(file.lflFileName); //'insert_drive_file';
                        $(file.previewElement).find('.dz-image img').replaceWith(
                            '<img src="' + iconUrl + '" alt="file-extenstion-icon"/>'
                        );
                    }
                }

                /*
                |-------------------------------------------------------------------------
                | Handler helpers */
            };
        }(Forms.Inputs, jQuery));
    }(Lfl.Forms, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
